export const ERRORS: any = {
  TRANSACTION_REFUNDED: 3000,
  PDF_RENDERING_FAILED: 6000,
  DUPLICATE_ENTITY: 999901,
};
